// JobPosting.js
import React from 'react';
import JobPostingForm from './JobPostingForm/JobPostingForm';
import Navbar from './Navbar';
import './JobPosting.css';

const JobPosting = () => {
  return (
    <div className="job-posting-wrapper">
      <Navbar />
      <div className="job-posting-page">
        <div className="job-posting-container">
          <h1 className="job-posting-title">Post a Job</h1>
          <JobPostingForm />
        </div>
      </div>
    </div>
  );
};

export default JobPosting;